var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Icon } from "../icon";
import { styledWithTheme } from "../../style/theme";
import { Pushable } from "./pushable";
var Container = styledWithTheme(Pushable)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  border: ", ";\n  background-color: ", ";\n  color: ", ";\n  white-space: nowrap;\n  text-transform: uppercase;\n  ", "\n  min-height: ", ";\n  font-size: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  border: ",
    ";\n  background-color: ",
    ";\n  color: ",
    ";\n  white-space: nowrap;\n  text-transform: uppercase;\n  ",
    "\n  min-height: ",
    ";\n  font-size: ",
    ";\n"])), function (p) { return p.theme.radius.small; }, function (p) {
    return p.variant === "outline"
        ? "1px solid " + (p.color === "brand"
            ? p.theme.palette.brandColor
            : p.color === "light"
                ? "white"
                : p.theme.palette.text.dark)
        : "1px solid transparent";
}, function (p) {
    return p.variant === "fill"
        ? p.color === "brand"
            ? p.theme.palette.brandColor
            : p.color === "light"
                ? "white"
                : p.theme.palette.text.dark
        : "none";
}, function (p) {
    return (p.variant === "fill" &&
        (p.color === "brand" || p.color === "dark" || !p.color)) ||
        (p.variant !== "fill" && p.color === "light")
        ? "white"
        : p.color === "brand" || (p.color === "light" && p.variant === "fill")
            ? p.theme.palette.brandColor
            : p.theme.palette.text.dark;
}, function (p) {
    return ({
        large: "padding-left: 1rem; padding-right: 1rem;",
        medium: "padding-left: 0.7rem; padding-right: 0.7rem;",
        small: "padding-left: 0.5rem; padding-right: 0.5rem;",
    }[p.size || "small"]);
}, function (p) {
    return ({
        large: "3rem",
        medium: "2.5rem",
        small: "2rem",
    }[p.size || "small"]);
}, function (p) {
    return ({
        large: p.theme.typography.variants.slabLarge.fontSize,
        medium: p.theme.typography.variants.slabMedium.fontSize,
        small: p.theme.typography.variants.slabSmall.fontSize,
    }[p.size || "small"]);
});
var ButtonIcon = styledWithTheme(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 120%;\n  margin-right: 0.4em;\n"], ["\n  font-size: 120%;\n  margin-right: 0.4em;\n"])));
export var Button = function (props) { return (React.createElement(Container, __assign({ pushScale: 0.95 }, props),
    props.icon && React.createElement(ButtonIcon, { icon: props.icon }),
    " ",
    props.children)); };
var templateObject_1, templateObject_2;
//# sourceMappingURL=button.js.map